export default {
      id: "oc-nutanix-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "sprite.svg#oc-nutanix",
      toString: function () {
        return this.url;
      }
    }